import {
    useFetchData,
    useParseRouteActions,
  } from "../../../helpers/GlobalHelper";
  import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
  import LmsTable from "../ui/LmsTable";
  import { IdProps } from "../../interfaces/Global";

  const MainTable = () => {
    const actionButtons = ["add", "edit", "remove", "export"];
    return <LmsTable 
      actionButtons={actionButtons} 
      apiSuffix="menu/gmr-project-cost" 
      deleteSuffix="menu/gmr-project-cost"
    />;
  };
  
  const newMenusGMRProjectCostFormFields = (myForm: BCFormController) => {
    myForm.addCenteredGroup([
      myForm.getInputField("Name", { required: true }),
      myForm.getCheckboxField("Is Active", { value: true, width: 3 }),
    ]);
  
    myForm.addCenteredGroup([
      myForm.getInputField("Description", { field: "textarea" }),
    ]);
  
    return myForm;
  };
  
  const EditNewMenusGMRProjectCostForm = ({ id }: IdProps) => {
    const [{ data = {}, isLoading, error }] = useFetchData(`menu/gmr-project-cost/${id}`);
    const myForm = newMenusGMRProjectCostFormFields(new BCFormController(data, { 
      submitSuffix: "menu/gmr-project-cost", 
      submitMethod: "PUT",
      deleteSuffix: "menu/gmr-project-cost",
    }));
    const formActions = ["save", "save-close", "delete", "close"];
    return (
      <LmsFormGenerator
        myForm={myForm}
        isLoading={isLoading}
        error={error}
        actions={formActions}
      />
    );
  };
  
  const AddNewMenusGMRProjectCostForm = () => {
    const myForm = newMenusGMRProjectCostFormFields(
      new BCFormController({}, { submitSuffix: "menu/gmr-project-cost", submitMethod: "POST", blankWidth: 5 })
    );
  
    const formActions = ["save-new", "save-continue", "save-close", "close"];
    return <LmsFormGenerator myForm={myForm} actions={formActions} />;
  };
  
  const LmsNewMenusGMRProjectCost = ({
    params = {},
    history,
  }) => {
    const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
      useParseRouteActions(params);
    if (!isActionAllowed) {
      history.goBack();
    }
  
    return (
      <>
        {isMainPage && <MainTable />}
        {isAdd && <AddNewMenusGMRProjectCostForm />}
        {isEdit && <EditNewMenusGMRProjectCostForm id={id} />}
      </>
    );
  };
  
  export default LmsNewMenusGMRProjectCost;
  